<template>
  <div id="the-artist">
    <b-container class="the-artist-container">
      <Header title="The Artist" />
      <ImageGallery
        style="margin-top: 40px"
        :data="[
          require('@/assets/images/galleries/NIKKO/NIKKO-IMG-01.jpg'),
          require('@/assets/images/galleries/NIKKO/NIKKO-IMG-02.jpg'),
          require('@/assets/images/galleries/NIKKO/NIKKO-IMG-03.jpg'),
          require('@/assets/images/galleries/NIKKO/NIKKO-IMG-04.jpg'),
          require('@/assets/images/galleries/NIKKO/NIKKO-IMG-05.jpg'),
        ]"
        :idString="'theartist'"
      />
      <h4>NIKKO WASHINGTON</h4>
      <p>
        Nikko Washington is a Chicago native raised in Hyde Park who excels in a
        variety of media, including paint, graphic design and screen printing.
        He’s known for creating expressive figures that speak beyond the canvas
        and has earned a solid reputation in Chicago’s music scene designing
        album covers for a wide range of hip-hop artists including Vic Mensa and
        Noname. Washington currently serves as the artistic director for Chicago
        hip-hop collective, Savemoney.
      </p>
      <p>
        To learn more about Nikko Washington, visit
        <a
          href="https://www.nikkowashington.com"
          target="_blank"
          v-ePitchTracking="{
            site: 'nikko',
            category: 'Link',
            label: 'Nikko Washington',
          }"
          >www.nikkowashington.com.</a
        >
      </p>
    </b-container>
  </div>
</template>

<script>
import ImageGallery from "@/components/global/ImageGallery";
import Header from "@/components/global/Header";
export default {
  name: "TheArtist",
  components: {
    ImageGallery,
    Header,
  },
};
</script>

<style lang="scss" scoped>
#the-artist {
  padding-bottom: 100px;
  @media (max-width: $md) {
    padding-bottom: 50px;
  }
  .the-artist-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    @media (max-width: $md) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  h4 {
    font-family: "Poppins-Bold";
    font-size: 20px;
    color: #1a1a1a;
    letter-spacing: 0;
    text-align: center;
    line-height: 24px;
    text-transform: uppercase;
    margin-top: 40px;
    margin-bottom: 20px;
  }
  p {
    font-family: "AvenirNext-Regular";
    font-size: 14px;
    color: #3e3e3e;
    text-align: center;
    line-height: 23px;
    margin-bottom: 50px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  a {
    color: #ce0e2d;
    text-decoration: none;
  }
}
</style>
